import { Navigate } from "react-router-dom";
import Constant from "../util/constant";

/**
 * Guestlist add + reports: CLUB_MANAGER and ADMIN only.
 * Club employees are redirected to POS (paid offline sale).
 */
const GuestlistRouteGuard = ({ children }) => {
  const role = window.localStorage.getItem("role");
  if (
    role !== Constant.ROLES.CLUB_MANAGER &&
    role !== Constant.ROLES.ADMIN
  ) {
    return <Navigate to="/club-offline-sale" replace />;
  }
  return children;
};

export default GuestlistRouteGuard;
